import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators, FormGroupDirective, NgForm, FormGroup } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { TrackService } from 'src/app/services/track.service';

@Component({
  selector: 'app-url',
  templateUrl: './add-url.component.html',
  styleUrls: ['./add-url.component.css']
})
export class AddUrlComponent implements OnInit {

  track = this.data.track;
  sessionId: number = this.data.sessionId;
  matcher = new MyErrorStateMatcher();
  talkLink = new FormControl('');
  formGroup = new FormGroup({ talkLink: this.talkLink});

  constructor(
      private trackService: TrackService,
      private  dialogRef: MatDialogRef<AddUrlComponent>,
      @Inject(MAT_DIALOG_DATA) public data: AddUrlComponent) { }

  ngOnInit(): void {
    const url = this.track.talkLink;
    this.formGroup.get('talkLink').setValue(url);
  }

  onSubmit(){
    this.matcher.submited = true;
    if (this.formGroup.invalid) {
      return;
    }
    if (this.track){
      this.transformToTrack();
      this.updateTrack();
    }
  }

  onClose() {
    this.dialogRef.close(this.track.talkLink);
  }
  transformToTrack(){
    this.track.talkLink = this.formGroup.get('talkLink').value;
    this.track.sessionId = this.sessionId;
  }

  updateTrack(){
    this.trackService.updateTrack(this.track.id, this.track)
      .subscribe(
        (_) => {
          this.onClose();
        },
        error => {
          console.error(error);
        }
      );
  }
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  submited = false;
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = this.submited;
    return !!(control && control.invalid && (isSubmitted));
  }
}

